import { Image } from "react-bootstrap";

const IconBox = ({ src, alt }: { src: string; alt: string }) => (
  <div className="icon-box">
    <Image src={src} alt={alt} />
  </div>
);

export default IconBox;
